import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import Switch from "@mui/material/Switch";
import React, { useEffect, useState } from "react";
import CustomInput from "../../../Components/input/CustomInput";
import { Link, useNavigate } from "react-router-dom";
import backbluebtn from "../../../Utils/Images/backbluebtn.png";
import CustomButton from "../../../Components/Button/CustomButton";
import { handleAddController } from "../../../APIs/Function/Controller/Controller";
import * as yup from "yup";
const AddController = () => {
  const schema = yup.object().shape({
    email: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
    password: yup.string().required("Password is required"),
    privillges: yup.array().min(1, "At least one privilege is required"),
  });

  const navigate = useNavigate();
  const label = { inputProps: { "aria-label": "Color switch demo" } };
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    privillges: [],
  });
  const initialFormData = {
    email: "",
    password: "",
    privillges: [],
  };
  const [loading, setLoading] = useState(false);
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleSwitchChange = (privilege) => {
    const updatedPrivileges = [...(formData.privillges || [])];

    if (updatedPrivileges.includes(privilege)) {
      updatedPrivileges.splice(updatedPrivileges.indexOf(privilege), 1);
    } else {
      updatedPrivileges.push(privilege);
    }

    setFormData({
      ...formData,
      privillges: updatedPrivileges,
    });

    localStorage.setItem("privileges", JSON.stringify(updatedPrivileges));
  };
  const resetForm = () => {
    setFormData({
      email: "",
      password: "",
      privillges: [],
    });
  };
  useEffect(() => {
    // Call the resetForm function when the component mounts
    resetForm();

    // Check for stored privileges
    // const storedPrivileges = localStorage.getItem("privileges");
    // if (storedPrivileges) {
    //   setFormData({
    //     ...formData,
    //     privillges: JSON.parse(storedPrivileges),
    //   });
    // }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      // Validate the form data against the schema
      await schema.validate(formData, { abortEarly: false });

      setLoading(true);
      let res = await handleAddController(formData);
      if (res.s) {
        setLoading(false);
        alert("Sub Admin Added Successfully");
        navigate("/controller");
      }
      setFormData(initialFormData);
    } catch (error) {
      if (error.name === "ValidationError") {
        // Yup validation error
        const validationErrors = {};
        error.inner.forEach((e) => {
          validationErrors[e.path] = e.message;
        });
        // Show an alert for each validation error
        Object.values(validationErrors).forEach((errorMsg) => {
          alert(`${errorMsg}`);
        });
      } else {
        // Other errors
        console.error("Error:", error);
      }
    }
  };

  console.log(formData);
  return (
    <>
      <Box>
        {" "}
        <Box
          sx={{
            bgcolor: "#31AEF4",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: { xs: "50px", md: "70px", lg: "70px" },
            p: "10px",
            boxSizing: "border-box",
          }}
        >
          <Link to={"/controller"}>
            <Box
              sx={{
                height: { xs: "50px", md: "60px", lg: "60px" },
                display: "flex",
                alignItems: "center",
              }}
            >
              <img height={"100%"} src={backbluebtn} alt="back" />
            </Box>
          </Link>
          <Box>
            <Typography
              sx={{
                fontFamily: "Open Sans",
                fontSize: { md: "30px", sm: "20px" },
                fontWeight: 600,
                lineHeight: "36px",
                color: "#FFFFFF",
              }}
            >
              Create Sub Admin
            </Typography>
          </Box>
          <Box>
            <CustomButton
              onClick={handleSubmit}
              sx={{
                width: { xs: "40px", md: "50px", lg: "80px" },
                height: { xs: "10px", md: "50px", lg: "50px " },
              }}
            >
              {loading ? <CircularProgress></CircularProgress> : "Save"}
            </CustomButton>
          </Box>
        </Box>
        <Box>
          <Container maxWidth="sm" sx={{ mt: "30px" }}>
            <form>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <CustomInput
                    label="Email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomInput
                    label="Password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    fullWidth
                    required
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Paper>
                    <Box sx={{ display: "flex" }}>
                      <Box
                        sx={{
                          border: "1px solid #E8E8E8",
                          width: "50%",
                          p: 2,
                          boxSizing: "border-box",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            User
                          </Typography>{" "}
                          <Switch
                            style={{
                              "&.MuiSwitch-colorDefault.Mui-checked": {
                                color: "red", // Red color when checked
                              },
                            }}
                            onChange={() => handleSwitchChange(1)}
                            {...label}
                            checked={formData.privillges.includes(1)}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            Product
                          </Typography>
                          <Switch
                            onChange={() => handleSwitchChange(2)}
                            {...label}
                            checked={formData.privillges.includes(2)}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            Chat
                          </Typography>
                          <Switch
                            onChange={() => handleSwitchChange(3)}
                            {...label}
                            checked={formData.privillges.includes(3)}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            Order
                          </Typography>
                          <Switch
                            onChange={() => handleSwitchChange(4)}
                            {...label}
                            checked={formData.privillges.includes(4)}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            Coupon
                          </Typography>
                          <Switch
                            onChange={() => handleSwitchChange(5)}
                            {...label}
                            checked={formData.privillges.includes(5)}
                          />
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          border: "1px solid #E8E8E8",
                          width: "50%",
                          p: 2,
                          boxSizing: "border-box",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            Workout
                          </Typography>{" "}
                          <Switch
                            onChange={() => handleSwitchChange(6)}
                            {...label}
                            checked={formData.privillges.includes(6)}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            Home Page Links
                          </Typography>
                          <Switch
                            onChange={() => handleSwitchChange(7)}
                            {...label}
                            checked={formData.privillges.includes(7)}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            Voucher
                          </Typography>
                          <Switch
                            onChange={() => handleSwitchChange(8)}
                            {...label}
                            checked={formData.privillges.includes(8)}
                          />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center ",
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: "17px",
                              fontFamily: "Open Sans",
                              fontWeight: 400,
                              color: "#737373",
                            }}
                          >
                            Notification
                          </Typography>
                          <Switch
                            onChange={() => handleSwitchChange(9)}
                            {...label}
                            checked={formData.privillges.includes(9)}
                          />
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </form>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default AddController;
